module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_9016.8aadd71b.png";